import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';

const routes = [
    {
        path: 'terminate-terms',
        name: routeName.TERMINATE_TERMS,
        component: () => import('@/views/aplCatl640and631/A7/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '部分投資終止說明', leaveAlert: true, code: 'A7', unableBack: true },
    },
    {
        path: 'terminate',
        name: routeName.TERMINATE,
        component: () => import('@/views/aplCatl640and631/A7/stopTarget/Index.vue'),
        meta: { auth: true, metaTitle: '部分投資終止', leaveAlert: true, code: 'A7', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.TERMINATE_TERMS, routeName.CONFIRM_DATA];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    }
];

export default routes;
